import axios from "axios";
import config from "../config/config";

const baseUrl = config.baseUrl;

export const saveTicket = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/create-ticket`,
            'data': data,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            message: respData.data.message,
            errors: respData.data.errors,
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const ticketHistory = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/ticket-history`,
            'data': data,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result,
            errors: respData.data.errors,
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const getTicket = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/ticket-detail`,
            'data': data,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result,
            errors: respData.data.errors,
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const saveReply = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/reply-ticket`,
            'data': data,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result,
            errors: respData.data.errors,
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

export const SubmitClose = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `${baseUrl}/close-ticket`,
            'data': data,
            'headers': {
                'authtoken': localStorage.getItem('accessToken')
            }
        });
        return {
            result: respData.data.result,
            errors: respData.data.errors,
        }
    }
    catch (err) {
        return {
            errors: returnErr(err)
        }
    }
}

function returnErr(err) {
    if (err.response && err.response.data && err.response.data.errors) {
        return err.response.data.errors;
    }
    else {
        return '';
    }
}


